import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * NOTE: Icons are kept for AccordionItems in order to preserve custom toggle animation,
 * using css border arrow hack prevents implementation of X/Y axis rotations
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from "../Icon";
import ArrowIcon from "./assets/arrow.svg";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * Link item with arrow right
 */
export function AccordionLink(_ref) {
  var title = _ref.title,
    href = _ref.href,
    onClick = _ref.onClick,
    isPseudo = _ref.isPseudo,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('item', className)
  }, /*#__PURE__*/React.createElement("a", {
    className: cx('tile', 'link'),
    href: href,
    onClick: onClick,
    role: "menuitem",
    tabIndex: 0
  }, title, isPseudo ? /*#__PURE__*/React.createElement(Icon, {
    className: cx('arrow'),
    name: "dropdownArrow"
  }) : null));
}
AccordionLink.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func,
  isPseudo: PropTypes.bool,
  className: PropTypes.string
} : {};

/**
 * Link item with arrow left, centered, used for "back" actions,
 * has all the same except isPseudo
 */
export function AccordionLinkReturn(_ref2) {
  var title = _ref2.title,
    href = _ref2.href,
    onClick = _ref2.onClick,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement(AccordionLink, {
    href: href,
    onClick: onClick,
    className: cx('back', className),
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowIcon, null), title)
  });
}
AccordionLinkReturn.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.node,
  // inheritedProps
  href: PropTypes.string,
  // inheritedProps
  onClick: PropTypes.func,
  // inheritedProps
  className: PropTypes.string // inheritedProps
} : {};
AccordionLinkReturn.defaultProps = {
  title: 'Назад'
};

/**
 * Dropdown toggle item with arrow up/down
 * can be rendered in alwaysOpen mode with no arrows by omitting isOpen, or passing null
 * or as always visible block by omitting isOpen
 */
export function AccordionDropdownStateless(_ref3) {
  var title = _ref3.title,
    children = _ref3.children,
    isOpen = _ref3.isOpen,
    onToggle = _ref3.onToggle,
    className = _ref3.className;
  var handleClick = onToggle && isOpen !== null ? function () {
    return onToggle(!isOpen);
  } : null;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('item', {
      alwaysOpen: isOpen === null,
      open: isOpen
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('tile'),
    onClick: handleClick,
    role: "menuitem",
    tabIndex: 0
  }, title, /*#__PURE__*/React.createElement(Icon, {
    className: cx('arrow'),
    name: "dropdownArrow"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, children));
}
AccordionDropdownStateless.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.node.isRequired,
  // represents text on the tile bar
  children: PropTypes.node.isRequired,
  // togglable content

  /**
   * Bool variable with three states:
   * - true: is maximized,
   * - false: is minimized,
   * - null: always Maximized with no controls
   */
  isOpen: PropTypes.oneOf([true, false, null]),
  onToggle: PropTypes.func,
  // called with true as first param if dropdown opens, false otherwise
  className: PropTypes.string
} : {};
AccordionDropdownStateless.defaultProps = {
  isOpen: null // initially alwaysOpen, with boolean value goes into toggleable mode
};

/**
 * Stateful version of Dropdown item, adds automatic isOpen control
 * onToggle can still be passed down to AccordionDropdown to use state externally
 */
export var AccordionDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionDropdown, _React$Component);
  var _super = _createSuper(AccordionDropdown);
  /** isOpen prop is only used for the initialization */
  function AccordionDropdown(props) {
    var _this;
    _classCallCheck(this, AccordionDropdown);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (isOpen) {
      var onToggle = _this.props.onToggle;
      _this.setState({
        isOpen: isOpen
      });
      if (onToggle) onToggle(isOpen);
    });
    _this.state = {
      isOpen: props.isOpen
    };
    return _this;
  }
  _createClass(AccordionDropdown, [{
    key: "render",
    value: function render() {
      var inheritedProps = this.props;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/React.createElement(AccordionDropdownStateless, _extends({}, inheritedProps, {
        isOpen: isOpen,
        onToggle: this.handleToggle
      }));
    }
  }]);
  return AccordionDropdown;
}(React.Component);
AccordionDropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.node.isRequired,
  // inheritedProps
  children: PropTypes.node.isRequired,
  // inheritedProps
  isOpen: PropTypes.bool,
  // acts as initial value
  onToggle: PropTypes.func,
  // inheritedProps
  className: PropTypes.string // inheritedProps
} : {};
AccordionDropdown.defaultProps = {
  isOpen: false // initially off, in toggleable mode, null may be passed to go into alwaysOpen mode
};

/**
 * Wrapper, can have AccordionLink or AccordionDropdown as children
 */
export function Accordion(_ref4) {
  var children = _ref4.children,
    isEnclosed = _ref4.isEnclosed,
    theme = _ref4.theme,
    className = _ref4.className,
    isFlat = _ref4.isFlat;
  var classes = cx('container', {
    blackTheme: theme === 'black',
    flat: isFlat,
    enclosed: isEnclosed
  }, className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    role: "menu"
  }, children);
}
Accordion.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  // AccordionLink or AccordionDropdown
  isEnclosed: PropTypes.bool,
  // if true, draws extra separator line before and after container
  isFlat: PropTypes.bool,
  // slightly changes visuals, removes horizontal indent and enlarges tabs
  theme: PropTypes.oneOf(['black']),
  className: PropTypes.string
} : {};